<template>
    <div id="biodigestor-cycles-widget-component">
        <WidgetWrapperComponent :title="$t('biodigestor_cycles')" id-widget="biodigestor-cycles-widget">
            <template v-slot:default>
                <v-row>
                    <v-col class="pa-2" cols="12" md="6">
                        <IconTitleValueCardComponent
                            :is-loading="fetchCyclesInformation"
                            :title="$t('Ventilateur')"
                            :value="$t(getSateFan())"
                            icon="mdi-fan"
                        />
                    </v-col>
                    <v-col class="pa-2" cols="12" md="6">
                        <IconTitleValueCardComponent
                            :date="values?.heater.time ?? ''"
                            :title="$t('Chauffage')"
                            :value="values && values.heater.value ? $t('up') : $t('off')"
                            icon="mdi-heat-pump-outline"
                        />
                    </v-col>
                    <v-col class="pa-2" cols="12" md="6">
                        <IconTitleValueCardComponent
                            :date="values?.mixing.time ?? ''"
                            :title="$t('Mélange')"
                            :value="values && values.mixing.value ? $t('in_progress') : $t('off')"
                            icon="mdi-rotate-3d-variant"
                        />
                    </v-col>
                    <v-col class="pa-2" cols="12" md="6">
                        <IconTitleValueCardComponent
                            :date="values?.hygienization.time ?? ''"
                            :title="$t('Hygiénisation')"
                            :value="$t(getStateHygienisation())"
                            icon="mdi-bottle-tonic-plus"
                        />
                    </v-col>
                </v-row>
            </template>
        </WidgetWrapperComponent>
    </div>
</template>

<script>
import deviceRepository from '@/repositories/DeviceRepository'
import WidgetWrapperComponent from '@/components/global/wrapper/WidgetWrapperComponent.vue'
import IconTitleValueCardComponent from '@/components/global/containment/IconTitleValueCardComponent.vue'

export default {
    name: 'BiodigestorCyclesWidgetComponent',
    components: {
        WidgetWrapperComponent,
        IconTitleValueCardComponent,
    },
    props: {
        asset: {
            type: Object,
            required: true,
        },
        device: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            values: null,
            fetchCyclesInformation: true,
        }
    },
    methods: {
        getStateHygienisation() {
            let state = 'None'
            if (this.values && this.values.intensity_fan) {
                switch (this.values.intensity_fan.value) {
                    case 1:
                        state = 'hygien_en_cours'
                        break
                    case 2:
                        state = 'hygien_finish'
                        break
                    case 3:
                        state = 'hygien_fail'
                        break
                    case 4:
                        state = 'hygien_asking'
                        break
                    default:
                        state = 'None'
                        break
                }
            }
            return state
        },
        getSateFan() {
            let state = 'off'
            if (this.values) {
                state = this.values.fan.value ? 'up' : 'down'
            }
            if (this.values && this.values.intensity_fan && this.values.intensity_fan.value !== 0) {
                switch (this.values.intensity_fan.value) {
                    case 1:
                        state = 'weak'
                        break
                    case 2:
                        state = 'medium'
                        break
                    case 3:
                        state = 'strong'
                        break
                    default:
                        state = 'off'
                        break
                }
            }
            return state
        },
        async getBiodigestorCyclesDeviceInformation() {
            this.fetchCyclesInformation = true
            return deviceRepository
                .getBiodigestorCyclesDeviceInformation(this.device.device_number)
                .then((success) => {
                    this.values = success.data.data
                })
                .catch((error) => {
                    this.manageError(error)
                })
                .finally(() => {
                    this.fetchCyclesInformation = false
                })
        },
    },
    mounted() {
        this.getBiodigestorCyclesDeviceInformation()
    },
}
</script>
